import React from "react";
import { Alert } from "reactstrap";

export default function AdminFlashMessage({ flash, onDismiss }) {
  if (!flash?.message) return null;

  return (
    <Alert color={flash.color || "info"} toggle={onDismiss} fade>
      {flash.message}
    </Alert>
  );
}